module.exports = __webpack_public_path__ + "img/provider5.4a7e149a.png";